export default {
  // 指令的定义
  mounted(el, binding) {
    let paddingLeft = ''
    el.addEventListener('mouseenter', (e) => {
      let dom = document.querySelector('div.right__main')
      dom.style.overflow = 'hidden'
      paddingLeft = dom.style.paddingRight
      dom.style.paddingRight = '26px'
    })
    el.addEventListener('mouseleave', (e) => {
      let dom = document.querySelector('div.right__main')
      dom.style.overflow = 'auto'
      dom.style.paddingRight = paddingLeft || '20px'
    })
  },
}